// Rendert einen String mit [Text](URL)-Links, **fett** und {platzhalter}-Werten.
const TOKEN = /(\[[^\]]+\]\([^)]+\)|\*\*[^*]+\*\*)/g;

const fill = (text, vars) =>
  text.replace(/\{(\w+)\}/g, (m, k) => (vars && k in vars ? String(vars[k]) : m));

export default function RichText({ text, vars, className = "" }) {
  const parts = fill(text, vars).split(TOKEN).filter(Boolean);
  return (
    <span className={className}>
      {parts.map((part, i) => {
        const link = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
        if (link) {
          return (
            <a
              key={i}
              href={link[2]}
              target="_blank"
              rel="noopener noreferrer"
              className="text-brand underline underline-offset-4"
            >
              {link[1]}
            </a>
          );
        }
        const bold = part.match(/^\*\*([^*]+)\*\*$/);
        if (bold) return <strong key={i} className="text-ink">{bold[1]}</strong>;
        return <span key={i}>{part}</span>;
      })}
    </span>
  );
}
